import { reportError } from '@/lib/errors'

let registered = false

/**
 * Registers a global handler for unhandled Promise rejections that fall outside
 * React Query's error boundary (e.g., useEffect cleanups, event handlers, timers).
 *
 * Idempotent — calling multiple times in a hot-reload environment only registers once.
 * Call from your app root (e.g., Providers or layout) once on mount.
 */
export function registerUnhandledRejectionHandler(): void {
  if (registered) return
  if (typeof window === 'undefined') return

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    reportError(event.reason, {
      context: {
        source: 'unhandledrejection',
        type: event.reason instanceof Error ? event.reason.name : typeof event.reason,
      },
    })
  })

  registered = true
}
